module.exports = __webpack_public_path__ + "../assets/img/2e075689bb4e9edd548377871662cce1.svg";